/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Box } from '@tishman/components';
import { ThemeUIStyleObject } from 'theme-ui';
import React from 'react';

import type { ReactNode } from 'react';

interface BorderedBoxProps {
  sx?: ThemeUIStyleObject;
  children?: ReactNode;
}

export const BorderedBox = ({
  sx,
  children,
}: BorderedBoxProps): JSX.Element => (
  <Box
    sx={{
      flex: ['1 1 auto', null, '1 1 36%'],
      width: '100%',
      position: 'relative',
      p: '10px',
      borderStyle: 'solid',
      borderWidth: '2px',
      borderColor: 'muted',
      my: ['24px', null, 0],
      overflow: 'hidden',
      ...sx,
    }}
  >
    <Box
      sx={{
        maxWidth: '100%',
        maxHeight: '100%',
        img: {
          'transition': '.5s ease all !important',
          '&:hover': {
            transform: 'scale(1.05)',
          },
        },
      }}
    >
      {children}
    </Box>
  </Box>
);
